// extracted by mini-css-extract-plugin
module.exports = {"container":"_3NL5B","svgContainer":"_3uDT0"};